





















import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import MainHeader from "../../../main/components/main-header/main-header.vue";
import NavLeft from "./components/nav-left.vue";
import LinchuangList from "../../../cdr/views/patient-list/sizhen-patients/sizhen-patients.vue";
import MingyiList from "../../../edr/views/patient-list/sizhen-patients/sizhen-patients.vue";
import ZhiweibingList from "../../../hdr/views/patient-list/sizhen-patients/sizhen-patients.vue";
import YingxiangList from "../../../idr/views/patient-list/sizhen-patients.vue";
import PatientList from "./components/patient-list.vue";
@Component({
  components: {
    MainHeader,
    NavLeft,
    LinchuangList,
    MingyiList,
    ZhiweibingList,
    YingxiangList,
    PatientList,
  },
})
export default class ZbsjkList extends Vue {
  private get center() {
    const localCenter = localStorage.getItem("center");
    if (!localCenter) {
      return {};
    } else {
      return JSON.parse(localCenter);
    }
  }
  /**
   * @description 初始化
   */
  private mounted() {
    // if (this.$route.query) {
    //   this.name = this.$route.query["name"];
    //   this.type = this.$route.query["type"];
    //   this.projectId = this.$route.query["project_id"];
    // }
  }
}
